<template>
  <v-card height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12" md="auto">
            <p>Stock Ownership <small id='ownership'>as of {{dateOwnership}}</small></p> 
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="auto">
            <v-text-field 
              v-model="search"
              append-icon="mdi-magnify"
              label="Filter"
              single-line
              hide-details
              style="max-width: 250px;"
              class="float-right"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
            <v-data-table
              v-show="!listLoad"
              :headers="headers"
              :items="itemsOwnership"
              :options.sync="options"
              :server-items-length="totalItems"       
              :loading="loading"   
              :mobile-breakpoint="0"    
              class="elevation-1"
              :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
            >
              <template v-slot:[`header.quantity`]>
                 <span class="pr-6"> # Shares </span> <br> (in thousands)
              </template>
              <template v-slot:[`header.shares_change`]>
               <span class="pr-6"> Shares Change</span> <br> (in thousands)
              </template>
              <template v-slot:[`header.weight`]>
               <span class="pr-6"> Investor</span> <br> Ptf Weight
              </template>
              <template v-slot:[`header.reported_as_of`]>
               <span class="pr-6"> Reported</span> <br> as of
              </template>
              <template v-slot:[`header.nb_shares_out`]>
               <span class="pr-6"> Shares</span> <br> Outstanding
              </template>

              <template v-slot:item="row">
                <tr>
                  <td>
                    <v-btn
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      :to="'/investors/analyze/' + row.item.id"       
                    > <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-magnify-plus-outline
                          </v-icon>                        
                        </template>
                        <span>Analyze</span>
                      </v-tooltip>                      
                    </v-btn>
                  </td>
                  <td class="lg">{{ row.item.name }}</td>                                  
                  <td class="lg">{{ row.item.classification }}</td>  
                  <td class="text-right md">
                    <span class="px-4">
                      {{ (row.item.quantity)/1000  | numeral('0,0') }}

                      <v-tooltip v-if="row.item.shares_change" top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :color="row.item.shares_change > 0 ? 'green': 'red'"
                            v-text="row.item.shares_change > 0 ? 'mdi-menu-up': 'mdi-menu-down'"
                          ></v-icon> 
                        </template>
                        <span> Share change: {{ (row.item.shares_change)/1000 | numeral('0,0') }}  </span>
                      </v-tooltip>
                      <v-tooltip v-else top>
                        <template v-slot:activator="{ on }">
                          <v-icon color="white" size="15" class="mx-1" v-on="on">
                            mdi-minus
                          </v-icon>
                        </template>
                        <span> Share change: {{ (row.item.shares_change)/1000 | numeral('0,0') }}  </span>
                      </v-tooltip>
                    </span>
                  </td>
                  <td class="text-right md">
                    <span class="px-4">
                      {{ (row.item.shares_change)/1000 | numeral('0,0') }}
                    </span>
                  </td>
                  <td class="text-right md">
                    <span class="px-4">
                      {{ row.item.weight | numeral('0.[00]%') }}
                    </span>
                  </td>                  
                  <td class="text-right">
                    <span class="px-4 text-no-wrap">
                      {{ row.item.reported_as_of}}
                    </span>
                  </td>
                  <td class="text-right sm">
                    <span class="px-4 text-no-wrap">
                      {{ row.item.nb_shares_out | numeral('0.[00]%')}}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  export default {
    name: 'StockAnalyzeComponentOwnership',
    props: ['stock'],
    data() {
      return {
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },          
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'Classification', value: 'classification' },
                  
          { text: '# Shares (in thousands $)', value: 'quantity', align: 'right' },
          { text: 'Shares Change (in thousands $)', value: 'shares_change', align: 'right' },
          { text: 'Investor Ptf Weight', value: 'weight', align: 'right' },          
          { text: 'Reported as of', value: 'reported_as_of', align: 'right' },
          { text: 'Shares Outstanding', value: 'nb_shares_out', align: 'right' },
        ],
        itemsOwnership: [],
        //itemsPortfolioAll:[],
        totalItems:0,
        listLoad: true,
        errorbar: false,
        dateOwnership:"",
        search:'',
        loading: false,
        options: {},    
        isTyping: false,    
      }
    },
    mounted () {
      this.getListFromApi();
    },    
    watch: {
      options: {
        handler () {
          this.getListFromApi();
        },
        deep: true,
      },
      search: {
        handler () {
          this.getListFromApi();
        },
        deep: true,
      },      
    },    
    methods: {            
      async getListFromApi() {
        var self = this
        this.loading=true;
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.options['search'] = this.search;
        //console.log(this.options)
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-stock-ownership/' + self.stock,this.options,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          // Check the response was a success
          self.itemsOwnership = response.data.ownership;
          self.dateOwnership = response.data.dateOwnership;
          //self.itemsPortfolioAll = response.data.constituentsAll;
          self.totalItems  = response.data.total;
          //console.log(response.data.constituents)
          self.loading=false;
          self.listLoad = false;
        }).catch(function (/*error*/) {
          //console.log(error)
          self.loading=false;          
          self.listLoad = false;
          //self.errorbar = true
        })
      }
    },
  }
</script>

<style scoped>
  td.sm {
    min-width: 150px;
  }
  td.md {
    min-width: 200px;
  }
  td.lg {
    min-width: 250px;
  }
</style>